export const siteStats = [
  { value: "1200+", label: "题材条目索引" },
  { value: "8", label: "主推短剧专题" },
  { value: "每周更新", label: "内容整理节奏" },
  { value: "4 类", label: "观看方式说明" },
];

export const navItems = [
  { id: "about", label: "站点导读" },
  { id: "featured", label: "编辑精选" },
  { id: "catalog", label: "题材选片" },
  { id: "ranking", label: "热看排行" },
  { id: "plot", label: "剧情看点" },
  { id: "guide", label: "观看指南" },
  { id: "characters", label: "角色图鉴" },
  { id: "faq", label: "常见问题" },
];

export const genres = [
  "全部",
  "都市温情",
  "家庭伦理",
  "逆袭成长",
  "悬疑情感",
  "治愈生活",
];

export const dramas = [
  {
    id: "d1",
    title: "春分之后",
    genre: "都市温情",
    tag: "单亲妈妈",
    summary:
      "年轻母亲在春分这天失去工作，也失去与孩子的日常作息。她一边重新寻找收入，一边学习如何向孩子解释生活的变化。",
    highlight: "用一整季的时间讲清一位母亲重新站起来的心理路径。",
    episodes: 24,
    status: "已完结",
    update: "全剧终",
    heat: "热度 9.8 万",
    score: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20young%20mother%20standing%20by%20a%20sunlit%20kitchen%20window%2C%20terracotta%20and%20cream%20palette%2C%20soft%20natural%20light%2C%20minimal%20clean%20background%2C%20paper%20texture%2C%20artistic%20mood%2C%20no%20text&width=600&height=800&seq=ym-poster-01&orientation=portrait",
  },
  {
    id: "d2",
    title: "她与光同行",
    genre: "逆袭成长",
    tag: "职场重启",
    summary:
      "离开职场三年的年轻母亲重新面试，从被质疑到被认可。她把育儿中练出的耐心，变成解决问题的独特方式。",
    highlight: "把家庭经验翻译成职场能力，是这部剧最有说服力的部分。",
    episodes: 30,
    status: "连载中",
    update: "每周三更新",
    heat: "热度 8.4 万",
    score: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20young%20woman%20walking%20through%20a%20bright%20city%20corridor%20with%20papers%20in%20hand%2C%20terracotta%20and%20cream%20palette%2C%20soft%20light%2C%20minimal%20background%2C%20artistic%20paper%20texture%2C%20no%20text&width=600&height=800&seq=ym-poster-02&orientation=portrait",
  },
  {
    id: "d3",
    title: "沉默的摇篮",
    genre: "家庭伦理",
    tag: "代际关系",
    summary:
      "两代母亲对养育方式各执一词，一件小事让隐藏多年的分歧浮出水面。争执之后，她们开始学习真正地倾听。",
    highlight: "把家庭矛盾写成可被理解的双向困境，而不是简单的对错。",
    episodes: 20,
    status: "已完结",
    update: "全剧终",
    heat: "热度 7.9 万",
    score: 8.9,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20wooden%20cradle%20in%20a%20quiet%20room%20with%20soft%20daylight%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20gentle%20mood%2C%20no%20text&width=600&height=800&seq=ym-poster-03&orientation=portrait",
  },
  {
    id: "d4",
    title: "第七个春天",
    genre: "治愈生活",
    tag: "慢节奏",
    summary:
      "搬到小城之后，年轻母亲开了间小小的早餐铺。她与邻里从陌生到熟络，用一顿顿早餐修补生活的裂缝。",
    highlight: "以食物与四季为线索，把治愈落在具体的生活细节上。",
    episodes: 18,
    status: "已完结",
    update: "全剧终",
    heat: "热度 6.6 万",
    score: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20cozy%20small%20breakfast%20shop%20counter%20with%20steam%20and%20morning%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=600&height=800&seq=ym-poster-04&orientation=portrait",
  },
  {
    id: "d5",
    title: "晚风知道",
    genre: "悬疑情感",
    tag: "悬念铺垫",
    summary:
      "一封没有署名的信打破了平静生活。年轻母亲循着线索回望过去，逐渐发现身边人各自掩藏着的难处。",
    highlight: "把悬疑当作理解的工具，越接近真相越接近人物的内心。",
    episodes: 26,
    status: "连载中",
    update: "每周五更新",
    heat: "热度 8.1 万",
    score: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20an%20envelope%20on%20a%20windowsill%20at%20dusk%20with%20swaying%20curtains%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20mysterious%20soft%20mood%2C%20no%20text&width=600&height=800&seq=ym-poster-05&orientation=portrait",
  },
  {
    id: "d6",
    title: "三十岁的答案",
    genre: "逆袭成长",
    tag: "自我选择",
    summary:
      "三十岁生日当天，她收到三份截然不同的人生提议。无论选哪一条路，都要先回答一个问题：她想要的到底是什么。",
    highlight: "把人生选择拆成具体的三次对话，节奏清晰不拖沓。",
    episodes: 22,
    status: "已完结",
    update: "全剧终",
    heat: "热度 7.2 万",
    score: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20young%20woman%20in%20thought%20by%20a%20city%20window%20with%20evening%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=600&height=800&seq=ym-poster-06&orientation=portrait",
  },
  {
    id: "d7",
    title: "旧巷里的母亲",
    genre: "家庭伦理",
    tag: "年代质感",
    summary:
      "一条老巷子，两代人，几十年间的聚散。年轻母亲接过上一辈的手艺，也接过她们没有说完的话。",
    highlight: "以手艺传承为线索，把亲情写得沉静而有分量。",
    episodes: 28,
    status: "连载中",
    update: "每周二更新",
    heat: "热度 7.5 万",
    score: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20narrow%20alley%20with%20hanging%20lanterns%20and%20aged%20walls%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20nostalgic%20mood%2C%20no%20text&width=600&height=800&seq=ym-poster-07&orientation=portrait",
  },
  {
    id: "d8",
    title: "米缸里的星星",
    genre: "治愈生活",
    tag: "亲子共看",
    summary:
      "母亲把每个月的愿望折成星星放进米缸。孩子一天天长大，也逐渐读懂了那些星星背后的心意。",
    highlight: "适合亲子一起观看，用童趣视角讲一份稳定的爱。",
    episodes: 16,
    status: "已完结",
    update: "全剧终",
    heat: "热度 6.1 万",
    score: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20folded%20paper%20stars%20in%20a%20rice%20jar%20on%20a%20wooden%20table%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20tender%20mood%2C%20no%20text&width=600&height=800&seq=ym-poster-08&orientation=portrait",
  },
];

export const featuredDramas = [
  {
    title: "沉默的摇篮",
    reason: "本周编辑首选",
    desc: "它没有把家庭矛盾简化成对错，而是让两代母亲各自说清自己的理由。看完之后，你会更愿意和家里人聊一次天。",
    meta: "家庭伦理 · 20 集 · 已完结",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20two%20generations%20of%20women%20sitting%20across%20a%20wooden%20table%20in%20soft%20daylight%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=900&height=600&seq=ym-feature-01&orientation=landscape",
  },
  {
    title: "旧巷里的母亲",
    reason: "口碑上升最快",
    desc: "线索藏在日常的小事里，越往后看越能体会上一辈的沉默。适合愿意慢下来、好好看一段故事的观众。",
    meta: "家庭伦理 · 28 集 · 连载中",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20hands%20passing%20a%20handmade%20craft%20in%20an%20old%20room%20with%20warm%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=900&height=600&seq=ym-feature-02&orientation=landscape",
  },
  {
    title: "她与光同行",
    reason: "职场线最扎实",
    desc: "把育儿中练出的能力变成职场优势，这条成长线写得具体可信，适合正在考虑重返职场的观众参考。",
    meta: "逆袭成长 · 30 集 · 连载中",
    poster:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20desk%20with%20notes%20and%20coffee%20in%20soft%20morning%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=900&height=600&seq=ym-feature-03&orientation=landscape",
  },
];

export const rankingList = [
  { rank: 1, title: "沉默的摇篮", trend: "持平", value: 98 },
  { rank: 2, title: "春分之后", trend: "上升 2", value: 94 },
  { rank: 3, title: "旧巷里的母亲", trend: "上升 1", value: 91 },
  { rank: 4, title: "她与光同行", trend: "持平", value: 88 },
  { rank: 5, title: "晚风知道", trend: "下降 2", value: 84 },
  { rank: 6, title: "第七个春天", trend: "上升 3", value: 79 },
];

export const plotPoints = [
  {
    title: "母子关系：把爱写成具体的事",
    text: "这类题材很少只靠台词表达亲情，而是把爱放进具体的行动里：早起准备的早餐、留在书包里的字条、深夜亮着的那盏灯。观众记住的往往是这些可触摸的细节。",
  },
  {
    title: "困境与选择：每个决定都有代价",
    text: "年轻母亲的难处通常来自多个方向，工作、家庭与自我期待彼此拉扯。好的写法会让每个选择都伴随明确的代价，而不是轻巧地两全其美。",
  },
  {
    title: "成长线：从被安排到主动决定",
    text: "成长并不等于变得强硬，而是逐渐学会表达需要、划出边界、承担后果。剧情通常用一连串小决定串起这条线，让转变显得可信。",
  },
  {
    title: "悬念节奏：信息一点点释放",
    text: "悬疑元素更适合当作理解的工具：每揭开一点真相，就多理解一个人物一点。节奏上常见做法是让悬念与情感同步推进，避免为了反转而反转。",
  },
  {
    title: "配角群像：让世界真实起来",
    text: "邻里、同事、长辈构成了故事的现实底色。他们不只是推动情节的工具，也会有自己的立场和难处，这样主角的选择才有参照。",
  },
  {
    title: "结局语气：治愈中留一点空间",
    text: "不少作品的结局并不追求彻底圆满，而是给出一个可以继续生活的方向。留白让观众进入故事之后，还能把感受带回自己的生活。",
  },
];

export const guideItems = [
  {
    icon: "ri-movie-2-line",
    title: "完整版与未删减的区别",
    text: "完整版通常指时间线连贯的成片顺序，未删减则强调内容未被剪辑处理。观看前先确认所需版本，再决定从哪里开始，可以避免剧情衔接不上。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "短剧与长剧的观看差异",
    text: "短剧单集更短、冲突更集中，适合碎片时间；长剧铺垫更充分、人物更完整，适合连续追看。按可用时间选择，体验会更好。",
  },
  {
    icon: "ri-list-ordered",
    title: "怎样按顺序看全集",
    text: "建议按更新顺序逐集观看，遇到分支回顾时再回看对应片段。若只想了解主线，可优先看关键转折集，再补看人物支线。",
  },
  {
    icon: "ri-device-line",
    title: "播放与设备适配建议",
    text: "桌面端适合长时段观看与对照剧情梳理，移动端适合通勤间隙。调整字号与亮度、开启字幕，都能明显提升连续观看的舒适度。",
  },
];

export const characters = [
  {
    name: "林晚",
    role: "年轻母亲 · 主线人物",
    desc: "做事细致、习惯先照顾别人。她的转折点，是学会把自己的需要也说出口。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20portrait%20illustration%20of%20a%20calm%20young%20mother%20in%20soft%20daylight%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=500&height=620&seq=ym-char-01&orientation=portrait",
  },
  {
    name: "小满",
    role: "孩子 · 情感锚点",
    desc: "用孩子的视角看待家里的变化，他的疑问常常替观众问出最直接的那一句。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20portrait%20illustration%20of%20a%20small%20child%20holding%20a%20paper%20star%20in%20warm%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=500&height=620&seq=ym-char-02&orientation=portrait",
  },
  {
    name: "陈姐",
    role: "长辈 · 引路人与对照",
    desc: "她代表上一代的经验，既是支持也是压力。她的沉默，往往是故事想要解释的部分。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20portrait%20illustration%20of%20an%20older%20woman%20with%20kind%20eyes%20in%20soft%20interior%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=500&height=620&seq=ym-char-03&orientation=portrait",
  },
  {
    name: "周叙",
    role: "关键人物 · 情感支线",
    desc: "他不替主角做决定，而是提出问题。这条支线的重点，是让主角更清楚自己想要什么。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20portrait%20illustration%20of%20a%20thoughtful%20man%20by%20a%20window%20at%20dusk%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=500&height=620&seq=ym-char-04&orientation=portrait",
  },
];

export const ratingBars = [
  { label: "情感真挚", value: 92 },
  { label: "人物立体", value: 86 },
  { label: "节奏舒适", value: 81 },
  { label: "细节真实", value: 89 },
];

export const reviews = [
  {
    name: "观众 · 半夏",
    score: "8.7",
    text: "最打动我的是那些没有说出口的关心，看的时候想起自己和妈妈之间的小事。",
  },
  {
    name: "观众 · 阿舟",
    score: "8.2",
    text: "节奏不着急，愿意花时间把一个人物讲透，这在短剧里挺难得的。",
  },
  {
    name: "观众 · 周末场",
    score: "7.9",
    text: "家庭线写得很真实，没有把任何一方写成坏人，看完更愿意去理解家人。",
  },
  {
    name: "观众 · 小满爸",
    score: "8.5",
    text: "和孩子一起看的，他会问很多问题。这种能聊起来的剧，我觉得挺有价值。",
  },
];

export const faqs = [
  {
    q: "「年轻的母亲在线」主要提供什么内容？",
    a: "本站以年轻母亲题材的短剧与剧情片为主题，整理题材条目、剧情看点、观看方式说明与延伸话题。所有内容都在本页「题材选片」与「剧情看点」等分区内呈现，方便一次性了解。",
  },
  {
    q: "完整版、短剧、看全集分别指什么？",
    a: "完整版强调时间线连贯的成片顺序，短剧指单集较短的连续剧形态，看全集则指按顺序完整观看。三者关注的角度不同，本页「观看指南」分区对它们的差异做了说明。",
  },
  {
    q: "未删减版和普通版本有什么差别？",
    a: "未删减通常指内容未经剪辑处理的版本。由于不同平台的处理方式并不一致，建议在观看前确认版本说明，再决定从哪一集开始。",
  },
  {
    q: "怎样在页面上筛选自己想看的题材？",
    a: "在「题材选片」分区点击都市温情、家庭伦理、逆袭成长等标签，即可在本页已有的条目中筛选。筛选只作用于当前页面内容，不会跳转到其他页面。",
  },
  {
    q: "页面上的排行和评分是怎么来的？",
    a: "排行与评分是本站编辑根据题材热度与观众反馈整理的示意数据，用于辅助浏览，不代表任何平台的官方数据，具体以你观看的平台为准。",
  },
  {
    q: "手机上阅读这些信息方便吗？",
    a: "页面按桌面端与移动端分别适配，长列表可换行、折叠内容可展开，主要正文在打开页面时即可阅读，不需要额外操作。",
  },
];

export const topics = [
  {
    icon: "ri-parent-line",
    title: "亲子沟通",
    text: "从剧情出发，聊聊如何向孩子解释生活里的变化，以及怎样听完他的话。",
  },
  {
    icon: "ri-briefcase-line",
    title: "重返职场",
    text: "把育儿中积累的耐心、计划与沟通能力，转化为可被看见的职场优势。",
  },
  {
    icon: "ri-time-line",
    title: "代际理解",
    text: "上一代的沉默常常有它的来处，理解并不等于认同，但会让对话变得可能。",
  },
  {
    icon: "ri-heart-3-line",
    title: "自我照顾",
    text: "照顾好自己不是自私，稳定的大人才能给出稳定的爱，这也是不少剧集想说的。",
  },
  {
    icon: "ri-live-line",
    title: "短剧观看习惯",
    text: "如何在碎片时间高效追剧、整理剧情脉络，以及避免被更新节奏牵着走。",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情分析入门",
    text: "从人物动机、冲突设置到结局语气，学会用几个角度读懂一部作品。",
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20young%20mother%20holding%20a%20child%20by%20a%20large%20sunlit%20window%2C%20terracotta%20and%20cream%20palette%2C%20soft%20natural%20light%2C%20minimal%20clean%20background%2C%20paper%20texture%2C%20artistic%20warm%20mood%2C%20no%20text&width=1000&height=1200&seq=ym-hero-01&orientation=portrait";

export const aboutImage =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20illustration%20of%20a%20quiet%20living%20room%20with%20plants%2C%20books%20and%20soft%20afternoon%20light%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20background%2C%20paper%20texture%2C%20no%20text&width=900&height=720&seq=ym-about-01&orientation=landscape";